
export class ConnectionInventoryItem {
  ID: string = "";
  BacklitKeyboard: boolean = false;
  HasFingerprintReader: boolean = false;
  HasPrivacyScreen: boolean = false;
  HasStylus: boolean = false;
  Category: string = "";
  CategoryID: string = "";
  CnetProdId: string = "";
  CpuFrequency: string = "";
  CpuModel: string = "";
  CpuVendor: string = "";
  DiskDriveSize: number = 0;
  DiskDriveUnit: string = "";
  DiskDriveType: string = "";
  HasTouchscreen: boolean = false;
  ImageLarge: string = "";
  IsEducation: boolean = false;
  IsParallelsCapable: boolean = false;
  IsSmartBuy: boolean = false;
  ListPrice: string = "";
  Locality: string = "";
  ManufactureImageLarge: string = "";
  ManufactureName: string = "";
  ManufacturePart: string = "";
  ManufactureURL: string = "";
  MaterialID: string = "";
  MaterialStatus: string = "";
  MaterialType: string = "";
  MemoryFrequency: string = "";
  MemorySize: number = 0;
  MemoryUnit: string = "";
  MemoryType: string = "";
  ParentCatDesc: string = "";
  ParentCatID: string = "";
  ParentMatGrp: string = "";
  ParentMatGrpId: string = "";
  ProductDescLong: string = "";
  ProductDescShort: string = "";
  ProductLine: string = "";
  ProductType: string = "";
  QtyAvailable: string = "";
  ScreenDPI: string = "";
  ScreenResolution: string = "";
  ScreenSize: string = "";
  ShowInResults: boolean = true;
  VendorURL: string = "";

  constructor() {}

  static getPrice(item: ConnectionInventoryItem): number {
    return parseFloat(item.ListPrice ?? "0");
  }
  static getScreenSize(item: ConnectionInventoryItem): number {
    return item.ScreenSize !== "" ? parseFloat(item.ScreenSize ?? "0") : 0;
  }
}
